import { BrandContextState, UserCentricsConsentState, subscribe } from '@seamless/one-context';
import {
  BRAND_CONTEXT_CONNECTION_NAME,
  COMPONENT_NAME,
  CONSENT_CONNECTION_NAME,
  QUALTRICS_BRAND_ATTRIBUTE,
  QUALTRICS_CONSENT_NAME,
  QUALTRICS_DEFAULT_BRAND,
  QUALTRICS_DIV_ID,
  QUALTRICS_SCRIPT_SRC,
  TENANT,
} from './constants';

function onDomReady(callback: () => void) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
}

function loadQualtricsOnConsent() {
  subscribe<UserCentricsConsentState[]>(CONSENT_CONNECTION_NAME, {
    tenant: TENANT,
    componentName: COMPONENT_NAME,
    callback: (state) => {
      if (state?.some((consent) => consent.name === QUALTRICS_CONSENT_NAME && consent.enabled)) {
        injectQualtricsScript();
      }
    },
  });
}

function injectQualtricsScript() {
  onDomReady(() => {
    const script = document.createElement('script');
    script.src = QUALTRICS_SCRIPT_SRC;
    script.async = true;
    if (document.body) {
      document.body.appendChild(script);
    }
  });
}

function addQualtricsDiv() {
  let qualtricsDiv: HTMLDivElement | null = null;

  subscribe<BrandContextState>(BRAND_CONTEXT_CONNECTION_NAME, {
    tenant: TENANT,
    componentName: COMPONENT_NAME,
    callback: (state) => {
      const brand = state.subBrand ?? QUALTRICS_DEFAULT_BRAND;

      if (!qualtricsDiv) {
        // Create and append div only on first call
        const mainDiv = document.querySelector('main')?.firstElementChild;
        qualtricsDiv = document.createElement('div');
        qualtricsDiv.id = QUALTRICS_DIV_ID;
        mainDiv?.appendChild(qualtricsDiv);
      }
      qualtricsDiv.setAttribute(QUALTRICS_BRAND_ATTRIBUTE, brand);
    },
  });
}

// adding div first
addQualtricsDiv();

// inject script
loadQualtricsOnConsent();
